import { getDatabaseContainerType, type AnalyticsClient } from '@databases/analytics';
import { getFieldType } from '@databases/fields';
import { type MessageFormatter } from '@databases/intl/intl-types';
import { messages } from '@databases/intl/messages';
import { doInsertFields } from '@databases/redux/contextual-menu/actions';
import { appStore } from '@databases/redux/store';
import { DatabaseFieldType } from '@databases/types/database';

import { Position } from '../../type.ts';

/**
 * Inserts a new field into the database content at the specified position,
 * dispatches the necessary Redux actions, and sends an analytics event.
 */
export async function insertFields({
  position,
  client,
  contentId,
  currentViewId,
  formatMessage
}: {
  position: Position;
  client: AnalyticsClient;
  contentId: string;
  currentViewId: string;
  formatMessage: MessageFormatter;
}) {
  const fieldType = getFieldType(DatabaseFieldType.TEXT);
  const newFieldLabel = formatMessage(
    messages['field-settings.field-name-inline-edit-default-text'],
    {
      defaultFieldName: formatMessage(fieldType.label)
    }
  );

  appStore.dispatch(
    doInsertFields(contentId, currentViewId, position === Position.BEFORE, newFieldLabel)
  );

  await client.sendInsertRowEvent({
    contentId: contentId,
    databaseContainer: getDatabaseContainerType()
  });
}
